<template>
  <div class="confirm-dialog-wrap">
    <span class="btn-close" @click="handleClose" />
    <div v-if="title" class="init-title">{{ title }}</div>
    <div class="text">
      <span v-html="text" />
    </div>
    <div class="ctrl">
      <span class="btn-confirm" @click="handleConfirm">{{ confirmText }}</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ConfirmDialog',
  props: {
    text: {
      type: String,
      default: '',
    },
    confirmText: {
      type: String,
      default: '我知道了',
    },
    title: {  
      type: String,
      default: '',
    }
  },
  methods: {
    handleClose() {
      this.$emit('close')
    },
    handleConfirm() {
      this.$emit('confirm')
      this.$emit('close')
    },
  },
}
</script>

<style lang="scss" scoped>
.confirm-dialog-wrap {
  z-index: 1000;
  position: fixed;
  left: 50%;
  top: 50%;
  width: 400px;
  min-height: 167px;
  background: #000;
  border-radius: 10px;
  transform: translate(-50%, -50%);
}
.text {
  display: table-cell;
  vertical-align: middle;
  width: 400px;
  height: 120px;
  line-height: 24px;
  text-align: center;
  font-size: 14px;
  color: #fff;
}
.ctrl {
  // position: absolute;
  // left: 0;
  // right: 0;
  // bottom: 25px;
  margin-top: 0px;
  margin-bottom: 25px;
  text-align: center;
}
.btn-confirm {
  display: inline-block;
  width: 184px;
  height: 40px;
  line-height: 40px;
  text-align: center;
  font-size: 14px;
  background: #f5b903;
  border-radius: 8px;
  color: #333;
  cursor: pointer;
}
.btn-close {
  position: absolute;
  right: 5px;
  top: 5px;
  width: 21px;
  height: 21px;
  background: url('~@/assets/images/close.png') 0 0 no-repeat;
  cursor: pointer;
  &:hover {
    background-position: -21px 0;
  }
  &:active {
    background-position: -42px 0;
  }
}
.init-title{
  color: #fff;
  font-size: 14px;
  font-weight: 500;
  text-align: center;
  margin-top: 20px;
}
</style>
